import axios from "axios";

/* =========================================================
   📰 FETCH FOLLOWING FEED (cursor pagination)
   cursor = ISO timestamp of the oldest post currently loaded
========================================================= */
export const fetchFeedHistory = async ({
  limit = 50,
  cursor = null,   // createdAt of the oldest post in the current list
} = {}) => {
  try {
    const params = new URLSearchParams({ limit: String(limit) });
    if (cursor) params.set("cursor", cursor);

    const res = await axios.get(`/api/feed?${params.toString()}`);
    return res.data;
  } catch (err) {
  
    throw err;
  }
};

/* =========================================================
   🌍 FETCH GLOBAL FEED (cursor pagination)
========================================================= */
export const fetchGlobalFeedHistory = async ({
  limit = 50,
  cursor = null,
} = {}) => {
  try {
    const params = new URLSearchParams({ limit: String(limit) });
    if (cursor) params.set("cursor", cursor);

    const res = await axios.get(`/api/feed/global?${params.toString()}`);
    return res.data;
  } catch (err) {
  
    throw err;
  }
};

/* =========================================================
   🔔 FETCH INTERACTIONS (cursor pagination)
========================================================= */
export const fetchInteractionHistory = async ({
  limit = 50,
  cursor = null,
} = {}) => {
  try {
    const params = new URLSearchParams({ limit: String(limit) });
    if (cursor) params.set("cursor", cursor);

    const res = await axios.get(`/api/feed/interactions?${params.toString()}`);
    return res.data;
  } catch (err) {
 
    throw err;
  }
};

/* =========================================================
   🔎 SEARCH USERS
   Searches by username and display name
========================================================= */
export const searchUsers = async ({
  q = "",
  limit = 20,
} = {}) => {
  try {
    const query = String(q).trim();

    if (query.length < 1) {
      return { users: [] };
    }

    const params = new URLSearchParams({
      q: query,
      limit: String(limit),
    });

    const res = await axios.get(
      `/api/feed/users/search?${params.toString()}`
    );

    return res.data;
  } catch (err) {
    throw err;
  }
};